
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

export default function BlogPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Tümü');

  const categories = ['Tümü', 'İnşaat Teknolojileri', 'Proje Güncellemeleri', 'Sektör Haberleri', 'Sürdürülebilirlik'];

  const blogPosts = [
    {
      id: 1,
      title: 'Modern İnşaat Teknolojilerinin Geleceği',
      category: 'İnşaat Teknolojileri',
      date: '15 Ocak 2024',
      author: 'Mimar Ahmet Yılmaz',
      excerpt: 'Yapay zeka, robotik ve sürdürülebilir malzemeler inşaat sektörünü nasıl dönüştürüyor? Gelecekteki inşaat projelerinde bizi bekleyen yenilikler...',
      image: 'https://public.readdy.ai/ai/img_res/3b02065c657f40acf92e39753133edef.jpg',
      readTime: '5 dk'
    },
    {
      id: 2,
      title: 'Ataşehir Residence Projesi İnşaat Güncellemesi',
      category: 'Proje Güncellemeleri',
      date: '12 Ocak 2024',
      author: 'Proje Ekibi',
      excerpt: 'Ataşehir Residence projesinde son durum: Kaba inşaat tamamlandı, ince işçilik aşamasına geçildi. Proje %65 tamamlanma oranına ulaştı...',
      image: 'https://readdy.ai/api/search-image?query=construction%20progress%20update%20showing%20building%20under%20construction%2C%20modern%20residential%20project%20development%2C%20construction%20site%20documentation%2C%20clean%20background&width=400&height=250&seq=26&orientation=landscape',
      readTime: '3 dk'
    },
    {
      id: 3,
      title: 'Sürdürülebilir İnşaat Malzemeleri Rehberi',
      category: 'Sürdürülebilirlik',
      date: '10 Ocak 2024',
      author: 'Dr. Elif Kaya',
      excerpt: 'Çevre dostu inşaat malzemeleri seçimi nasıl yapılır? Geri dönüştürülebilir malzemeler ve enerji verimliliği konularında uzman görüşleri...',
      image: 'https://readdy.ai/api/search-image?query=sustainable%20construction%20materials%20display%2C%20eco-friendly%20building%20supplies%20and%20green%20construction%20products%2C%20environmental%20building%20materials%2C%20clean%20background&width=400&height=250&seq=27&orientation=landscape',
      readTime: '7 dk'
    },
    {
      id: 4,
      title: '2024 İnşaat Sektörü Trend Analizi',
      category: 'Sektör Haberleri',
      date: '8 Ocak 2024',
      author: 'Ekonomist Mehmet Demir',
      excerpt: 'İnşaat sektöründe 2024 yılında beklenen gelişmeler, piyasa analizi ve yatırım fırsatları. Sektörün geleceğine dair önemli veriler...',
      image: 'https://readdy.ai/api/search-image?query=construction%20industry%20analysis%20charts%20and%20graphs%2C%20business%20data%20visualization%20for%20building%20sector%2C%20market%20trends%20and%20statistics%2C%20clean%20background&width=400&height=250&seq=28&orientation=landscape',
      readTime: '6 dk'
    },
    {
      id: 5,
      title: 'Akıllı Bina Sistemleri ve IoT Entegrasyonu',
      category: 'İnşaat Teknolojileri',
      date: '5 Ocak 2024',
      author: 'Mühendis Ayşe Özkan',
      excerpt: 'Akıllı ev teknolojileri ve IoT sistemlerinin modern binalardaki uygulamaları. Enerji tasarrufu ve yaşam kalitesi artışı...',
      image: 'https://readdy.ai/api/search-image?query=smart%20building%20technology%20with%20IoT%20sensors%20and%20automation%20systems%2C%20modern%20intelligent%20building%20interior%2C%20connected%20home%20technology%2C%20clean%20background&width=400&height=250&seq=29&orientation=landscape',
      readTime: '4 dk'
    },
    {
      id: 6,
      title: 'Kadıköy Plaza Projesi Tamamlandı',
      category: 'Proje Güncellemeleri',
      date: '3 Ocak 2024',
      author: 'Proje Ekibi',
      excerpt: 'Kadıköy Plaza projesi başarıyla tamamlandı. Modern ofis ve ticari alanlardan oluşan proje, bölgenin yeni cazibe merkezi olmaya hazırlanıyor...',
      image: 'https://readdy.ai/api/search-image?query=completed%20modern%20commercial%20plaza%20building%20exterior%2C%20finished%20construction%20project%20with%20glass%20facade%2C%20successful%20building%20completion%2C%20clean%20background&width=400&height=250&seq=30&orientation=landscape',
      readTime: '3 dk'
    }
  ];

  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'Tümü' || post.category === selectedCategory;
    
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Blog
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              İnşaat sektöründeki gelişmeler, proje güncellemeleri ve uzman görüşleri
            </p>
          </div>
        </div>
      </section>

      {/* Arama ve Filtreler */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Blog yazılarında ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[14px] w-full md:w-80"
              />
            </div>
            
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-[14px] font-medium transition-all duration-200 whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-[#0e3851] text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredPosts.length === 0 ? (
            <div className="text-center py-12">
              <i className="ri-article-line text-[48px] text-gray-300 mb-4"></i>
              <h3 className="text-[18px] font-semibold text-gray-600 mb-2">Yazı bulunamadı</h3>
              <p className="text-[15px] text-gray-500">Arama kriterlerinizi değiştirerek tekrar deneyin.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <Card key={post.id} hover>
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover rounded-xl mb-4"
                  />
                  
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-3 py-1 bg-[#0e3851]/10 text-[#0e3851] text-[12px] font-medium rounded-full">
                      {post.category}
                    </span>
                    <div className="flex items-center text-[12px] text-gray-500">
                      <i className="ri-time-line mr-1"></i>
                      {post.readTime}
                    </div>
                  </div>
                  
                  <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2 line-clamp-2">
                    {post.title}
                  </h3>
                  
                  <p className="text-[14px] text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  
                  <div className="flex items-center justify-between text-[12px] text-gray-500 mb-4">
                    <span>{post.author}</span>
                    <span>{post.date}</span>
                  </div>
                  
                  <Link to={`/blog/${post.id}`}>
                    <Button variant="outline" size="sm" className="w-full">
                      <i className="ri-arrow-right-line mr-2"></i>
                      Devamını Oku
                    </Button>
                  </Link>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
